import React, { useState, useEffect, useRef } from 'react';
import { Image as AntdImage, Tree, Dropdown, Modal, Form, Input, TreeSelect, message } from 'antd';
import { EllipsisOutlined, PlusOutlined } from '@ant-design/icons';


import {ModalConfirm } from '../../../../utils/tool';
import Api from "../../../../api";
import recentlyIcon from "../../../../assets/img/V7/recentlyIcon.svg";
import SpaceInfo from "../spaceInfo/index";
import {zuStandStore} from "../../../../zustand";
import "./index.scss";

const PersonalTree = ({
    treeSelectChange
}) => {
     const moreChildrenOperationList = [
        { label: '新建子分类', key: 'add' },
        { label: '重命名', key: 'updata' },
        { label: '复制到...', key: 'copy' },
        { label: '移动到...', key: 'move' },
        { label: '排序', key: 'order' },
        {label: '删除', key: 'delete' },
    ];
    const [operationType, setOperationType] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false); // 添加/编辑 分类
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [addForm] = Form.useForm();
    const treeRef = useRef(null);
    const [checkTreeIds,setCheckTreeIds] = useState([]);
    const [selectedSpaceTypeId, setSelectedSpaceTypeId] = useState(null);
    const [spaceTreeData, setSpaceTreeData] = useState([]);
    const [seleteTreeNode,setSeleteTreeNode] = useState("");
    const [showMoreBoxId, setShowMoreBoxId] = useState(null);
    const [editParam, setEditParam] = useState("");
    const [treeModalOpen, setTreeModalOpen] = useState(false);

    const [recently, setRecently] = useState(true);

    const zuStandState = zuStandStore((state) => state);
    const changeSpaceTypeIdsFunc = zuStandState.changeSpaceTypeIds;

    useEffect(() => {
        getSpaceTree();
    }, []);
    const getSpaceTree = async () => {
        const res = await Api.PersonalCenter.querySpaceTree({});
        if (res && res.code == 0) {
            setSpaceTreeData(res.data);
        }
    };

    const onTreeNodeCheck = (selectedKeys, info) => {
        console.log(selectedKeys, info);
        let _selectedKeys = selectedKeys.checked;
        if(_selectedKeys.length <= 0){
            setRecently(true);
        }else{
            setRecently(false);
        }
        setCheckTreeIds(_selectedKeys);
        changeSpaceTypeIdsFunc(_selectedKeys);
        treeSelectChange({
            "spaceTypeIds": _selectedKeys
        })
    }

    const clearSelect = () => {
        setCheckTreeIds([]);
        changeSpaceTypeIdsFunc([]);
        treeSelectChange({
            "spaceTypeIds": []
        })
    }

    const onMoreOperationChange = (e, showMoreId) => {
        setOperationType(e.key);
        if(e.key === 'add'){
            setIsModalOpen(true);
            setEditParam("");
            setSeleteTreeNode("");
            if (showMoreId) {
                addForm.setFieldsValue({
                    parentId: showMoreId,
                });
            }

        }else if(e.key === 'updata' || e.key === 'order'){
            setIsModalOpen(true);
            addForm.setFieldsValue({
                name: editParam.name,
                orderNum: editParam.orderNum,
                parentId: editParam.parentId,
            });
        }else if(e.key === 'delete'){
            deleteSpaceTreeF();
        }else if(e.key === 'move' || e.key === 'copy'){
            setTreeModalOpen(true);
        }
    }

    const deleteSpaceTreeF = async () => {
        ModalConfirm({
            title: `您确认要删除 "${editParam.name}" 分类吗?`,
            onOk:async(resolve, reject)=> {
                try{
                    const res = await Api.PersonalCenter.deleteSpaceTree({data:{id:editParam.id}});
                    if(res && res.code === 0){
                        getSpaceTree();
                        message.success("删除成功")
                    }
                    resolve();
                }catch{}
            },
        })
    }

    // 新增
    const handleOk = async() => {
        try {
            const row = await addForm.validateFields();
            console.log(row, editParam.id);
            if(operationType === "edit" && row.parentId === editParam.id){
                message.info("父级菜单不能为自己");
                return false
            }
            setConfirmLoading(true);
            if(editParam.id){
                row.id = editParam.id
                updataSpaceTreeF(row)
            }else{
                addSpaceTreeF(row);
            }
        } catch (errInfo) {
            console.log('验证失败:', errInfo);
        }
    }

    const updataSpaceTreeF = async (row) => {
        const res = await Api.PersonalCenter.updataSpaceTree({data:row});
        if(res&&res.code === 0){
            message.success("操作成功",2,()=>{
                handleCancel();
                getSpaceTree();
            })
        }else{setConfirmLoading(false);}
    }

    const addSpaceTreeF = async (row) => {
        const res = await Api.PersonalCenter.addSpaceTree({data:row});
        if(res&&res.code === 0){
            message.success("操作成功",2,()=>{
                handleCancel();
                getSpaceTree();
            })
        }else{setConfirmLoading(false);}
    }

    // 关闭新增
    const handleCancel = () => {
        setConfirmLoading(false);
        setIsModalOpen(false);
        setEditParam("");

        setTreeModalOpen(false);
        setSeleteTreeNode("");
        setSelectedSpaceTypeId(null);
    }

    const moveTreeNodeOk = () => {
        if(!seleteTreeNode){
            message.info("请选择分类");
            return false
        }
        if(seleteTreeNode === editParam.parentId){
            message.info("你当前已在此分类下");
            return false
        }
        if(seleteTreeNode === editParam.id){
            message.info("分类不能选择本身");
            return false
        }

        if(operationType === 'move'){
            updataSpaceTreeF({id:editParam.id,parentId:seleteTreeNode})
        }else if(operationType === 'copy'){
            addSpaceTreeF({
                parentId:seleteTreeNode,
                name: editParam.name,
                orderNum: editParam.orderNum,
            })
        }
    }

    const moveTreeNodeCancel = () => {
        setTreeModalOpen(false);
        setConfirmLoading(false);
        setEditParam("");
        setSeleteTreeNode("");
    }

    const onTreeNodeSelect = (selectedKeys, info) => {
        setSeleteTreeNode(selectedKeys[0])
    }

    return(
        <div className="personalTreeFrameV7">
            <div 
                className={`recentlyBtn ${recently ? 'active':''}`}  
                    onClick={()=>{
                        if(!recently){
                            setRecently(!recently);
                            clearSelect();
                        }
                        
                    }}>
                <AntdImage
                    src={recentlyIcon}
                    preview={false}
                />最近
            </div>
            <div className={`addClassify`}  
                    onClick={()=>{
                        setSelectedSpaceTypeId(null);
                        onMoreOperationChange({"key":"add"});
                    }}>
                <PlusOutlined />新建分类
            </div>
            <Tree
                ref={treeRef}
                checkable
                defaultExpandAll={true}
                checkedKeys={checkTreeIds}
                selectedKeys={[selectedSpaceTypeId]}
                onCheck={onTreeNodeCheck}
                onSelect={(selectedNodeKeys, evt) => {
                    const treeInstance = treeRef.current;
                    if (treeInstance) {
                        const {node} = evt;
                        treeInstance.onNodeCheck(evt, node, !node.checked);
                    }
                }}
                treeData={spaceTreeData}
                fieldNames={{ title: 'name', key: 'id', children: 'children' }}
                rootClassName={`spaceTreeBox`}
                onMouseLeave={(e) => {setShowMoreBoxId(null)}}
                checkStrictly={true}
                titleRender={(node) => {
                    return (
                        <div
                            onMouseEnter={(e) => {
                                setShowMoreBoxId(node.id)
                                setEditParam(node);
                            }}
                        >
                            {node.name}
                            {
                                showMoreBoxId === node.id && (
                                    <Dropdown
                                        menu={{
                                            items: moreChildrenOperationList,
                                            onClick: (e) => {
                                                e.domEvent?.stopPropagation();
                                                e.domEvent?.preventDefault();
                                                setSelectedSpaceTypeId(node.id);
                                                onMoreOperationChange(e, showMoreBoxId);
                                            }
                                        }}
                                    >
                                        <div
                                            className="moreIcon"
                                            onClick={(e) => {
                                                e?.stopPropagation();
                                                e?.preventDefault();
                                            }}
                                        >
                                            <EllipsisOutlined />
                                        </div>
                                    </Dropdown>
                                )
                            }
                    </div>
                    )
                }}
            >
            </Tree>


            {/* 空间使用状态 */}
            <SpaceInfo/>  

                                
             {/* 新增/编辑 子分类 */}
            <Modal
                title={`${operationType === "add" ? "新增" : "编辑"}子分类`}
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                maskClosable={false}
                destroyOnClose={true}
                centered={true}
                confirmLoading={confirmLoading}
                wrapClassName={"personCenterAddModalBox"}
            >
                <Form
                    form={addForm}
                    component={false}
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 14 }}
                    preserve={false}
                >
                    {
                        selectedSpaceTypeId ? (
                            <Form.Item
                                key={'parentId'}
                                label={'上级分类'}
                                name={'parentId'}
                            >
                                <TreeSelect
                                    disabled={operationType === "add"}
                                    // allowClear
                                    treeDefaultExpandAll
                                    treeData={spaceTreeData}
                                    fieldNames={{
                                        label:"name",
                                        value:"id"
                                    }}
                                />
                            </Form.Item>
                        ) : undefined
                    }

                    <Form.Item
                        key={'name'}
                        label={'分类名称'}
                        name={'name'}
                        rules={[
                            {
                                required: true,
                                message: `请输入分类名称!`
                            },
                        ]}
                    >
                        <Input type={'text'} />
                    </Form.Item>
                    <Form.Item
                        key={'orderNum'}
                        label={'序号'}
                        name={'orderNum'}
                    >
                        <Input type={'number'}/>
                    </Form.Item>
                </Form>
            </Modal>
                    {/* 移动/复制分类 */}
            <Modal
                title="选择分类"
                open={treeModalOpen}
                onOk={moveTreeNodeOk}
                onCancel={moveTreeNodeCancel}
                maskClosable={false}
                destroyOnClose={true}
                centered={true}
                wrapClassName={"personCenterAddModalBox"}
                confirmLoading={confirmLoading}
                width={400}
            >
                <Tree
                    style={{marginLeft: 30}}
                    defaultExpandAll={true}
                    treeData={spaceTreeData}
                    fieldNames={{ title: 'name', key: 'id', children: 'children' }}
                    rootClassName={"spaceTreeBox"}
                    onSelect={onTreeNodeSelect}
                />
            </Modal>
        </div>
    )
}

export default PersonalTree;
